(ns admin.events.containers.activity.evaluations
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]
            [kyber.utils :as ku]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get container page success"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name _ {{:activity/keys [evaluation]
                                activity-uuid :activity/uuid} :>/activity}]]
  (let [->qcontext (fn [q]
                     (let [qcontext (ku/select-ns-keys q :question.context)
                           question (ku/select-ns-keys q :question)]
                       (assoc qcontext :question.context/question question)))
        formatted-evaluation (-> evaluation
                                 (assoc :activity/uuid activity-uuid)
                                 (update :questionnaire/questions #(mapv ->qcontext %)))
        tx {:activity/uuid activity-uuid
            :activity/evaluation formatted-evaluation}]
    {:db (cond-> db 
           (some? evaluation)
           (kyber-db/tx-record {:model :activity} tx))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)


(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get container page failure"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)


(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get container page request"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(def base-resource-keys
  [:resource/uuid
   :resource/created-at
   :resource/created-by
   :resource/download-key
   :resource/download-path
   :resource/duration
   :resource/description
   :resource/failed?
   :resource/file-name
   :resource/file-size
   :resource/file-type
   :resource/name
   :resource/page-count
   :resource/source-key
   :resource/source-path
   :resource/status
   :resource/url
   :resource/m3u8
   :resource/viewer-key
   :resource/viewer-path])

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid] :as params}]]
  (let [resource-sub-query [:resource/uuid]

        assessment-question-sub-query [:question/uuid
                                       :question/body
                                       :question/results
                                       :question/key?
                                       :question/other-enabled
                                       :question/type
                                       :question/educator-feedback
                                       :question/has-correctness?
                                       :question/include-poll-data
                                       {:question/subject-matter-object base-resource-keys}
                                       {:question/headers [:question.header/uuid
                                                           :question.header/body
                                                           :question.header/index]}
                                       {:question/choices [:question.choice/body
                                                           :question.choice/correct-answer
                                                           :question.choice/uuid]}

                                       :question.context/uuid
                                       :question.context/confidence-enabled?
                                       :question.context/assessment-type
                                       :question.context/is-required?
                                       {:question.context/resources resource-sub-query}
                                       {:question.context/learning-objective [:learning-objective/uuid
                                                                              :learning-objective/label]}]

        questionnaire-sub-query [:questionnaire/uuid
                                 :questionnaire/context
                                 :questionnaire/feedback-display-strategy
                                 :questionnaire/max-attempts
                                 :questionnaire/pass-percent
                                 :questionnaire/pass-message
                                 :questionnaire/fail-message
                                 :questionnaire/pre-test-pass-percent
                                 :questionnaire/results-display-strategy
                                 :questionnaire/can-test-out?
                                 {:questionnaire/questions assessment-question-sub-query}]]
    {:db db
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]
     :request
     (eql/request
      db
      {:name event-name
       :params `[{(:>/activity {:curriculum/uuid ~curriculum-uuid
                                :activity/uuid ~activity-uuid})
                  [:activity/uuid
                   {:activity/evaluation ~questionnaire-sub-query}]}]
       :on-success [::fetch-container-data-success params]
       :on-failure [::fetch-container-data-failure params]})}))

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-container
  (partial ensure-resource-v2 ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))

